// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_POST_CREATE_OPTIONS = "Mo\u017enosti";
export const SEND = "Ode\u0161li";
export const SEO_TITLE_FORUM_THREAD_NEW = "P\u0159idej p\u0159\u00edsp\u011bvek";
